// src/components/EditUsersModal.js
import React, { useState, useEffect } from "react";
import { API_URL } from "../config";

const ROLES = ["Admin", "Moderator", "User"];
const POSITIONS = [
  "Szef", "Manager", "Project Manager", "Pracownik",
  "Logistyk", "Projektant", "Programista", "Gość"
];

function EditUsersModal({ onClose, onUserUpdated }) {
  const [users, setUsers] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    birth_date: "",
    hire_date: "",
    departure_date: "",
    role: "User",
    position: "Pracownik",
  });
  const [msg, setMsg] = useState("");

  // pobieramy listę użytkowników po otwarciu modala
  useEffect(() => {
    fetch(`${API_URL}/users`, {                 // ✅ Krok 2: zamiast onrender
      credentials: "include",
    })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => setUsers(Array.isArray(data) ? data : [])) // opcjonalnie bezpieczniej
      .catch((e) => console.error(e));
  }, []);

  // po wyborze użytkownika wczytujemy jego dane do formularza
  useEffect(() => {
    if (!selectedId) return;
    const u = users.find((u) => String(u.id) === selectedId);
    if (u) {
      const { first_name, last_name, birth_date, hire_date, departure_date, role, position } = u;
      setForm({
        first_name,
        last_name,
        birth_date,
        hire_date,
        departure_date: departure_date || "",
        role,
        position
      });
    }
  }, [selectedId, users]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const res = await fetch(`${API_URL}/users/${selectedId}`, {  // ✅ Krok 2
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      setMsg("Zapisano zmiany ✔️");
      onUserUpdated?.();
    } catch (err) {
      console.error(err);
      setMsg("❌ Błąd zapisu");
    }
  };

  const handleForcePwd = async () => {
    try {
      const res = await fetch(`${API_URL}/users/${selectedId}/forcePasswordChange`, { // ✅ Krok 2
        method: "POST",
        credentials: "include",
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      setMsg("Przy kolejnym logowaniu użytkownik musi zmienić hasło ✔️");
      onUserUpdated?.();
    } catch (err) {
      console.error(err);
      setMsg("❌ Błąd");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Edytuj użytkownika</h3>

        <label>Wybierz użytkownika:</label>
        <select value={selectedId} onChange={(e) => setSelectedId(e.target.value)} required>
          <option value="" disabled>-- wybierz --</option>
          {users.map((u) => (
            <option key={u.id} value={u.id}>
              {u.login} ({u.first_name} {u.last_name})
            </option>
          ))}
        </select>

        {selectedId && (
          <form className="edit-user-form" onSubmit={(e) => e.preventDefault()}>
            <input
              type="text"
              name="first_name"
              placeholder="Imię"
              value={form.first_name}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="last_name"
              placeholder="Nazwisko"
              value={form.last_name}
              onChange={handleChange}
              required
            />
            <label>Data urodzenia:</label>
            <input
              type="date"
              name="birth_date"
              value={form.birth_date?.substring(0, 10) || ""}
              onChange={handleChange}
              required
            />
            <label>Data przyjęcia:</label>
            <input
              type="date"
              name="hire_date"
              value={form.hire_date?.substring(0, 10) || ""}
              onChange={handleChange}
              required
            />
            <label>Data odejścia (opc.):</label>
            <input
              type="date"
              name="departure_date"
              value={form.departure_date?.substring(0, 10) || ""}
              onChange={handleChange}
            />

            <label>Rola:</label>
            <select name="role" value={form.role} onChange={handleChange}>
              {ROLES.map((r) => (
                <option key={r} value={r}>{r}</option>
              ))}
            </select>

            <label>Stanowisko:</label>
            <select name="position" value={form.position} onChange={handleChange}>
              {POSITIONS.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
          </form>
        )}

        <div className="modal-buttons" style={{ marginTop: "1.2rem" }}>
          <button className="btn-submit" onClick={handleSave} disabled={!selectedId}>
            Zapisz zmiany
          </button>
          <button className="btn-submit" onClick={handleForcePwd} disabled={!selectedId}>
            Wymuś zmianę hasła
          </button>
          <button className="btn-submit" onClick={onClose}>
            Zamknij
          </button>
        </div>

        {msg && <p style={{ marginTop: "0.5rem" }}>{msg}</p>}
      </div>
    </div>
  );
}

export default EditUsersModal;
